// Textos de la ficha de usuario del backoffice (user-detail). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    USER_DETAIL: {
      BACK: 'Volver a usuarios',
      LOADING: 'Cargando el usuario…',
      LOAD_ERROR: 'No se ha podido cargar el usuario.',
      COMMON: {
        VERIFIED: 'Verificado',
        UNVERIFIED: 'Sin verificar',
        CANCEL: 'Cancelar',
        ACCEPT: 'Aceptar',
        ERROR: 'Error',
        CLOSE: 'Cerrar',
      },
      BREADCRUMB: {
        ARIA: 'Ruta de navegación',
        USERS: 'Usuarios WAIIS',
        DETAIL: 'Detalle',
      },
      SUPPORT_CHAT_PICK: {
        TITLE: '¿Qué chat quieres abrir?',
        PRIVATE: 'Chat privado',
        PRIVATE_SUB: 'Solo el usuario y soporte',
        PRIVATE_NEW_SUB: 'Todavía no existe: se crea al abrirlo',
        GROUP: 'Chat grupal del trayecto',
        GROUP_NAMED: 'Chat grupal · {{name}}',
        LAST_ACTIVITY: 'Última actividad {{when}}',
        CANCEL: 'Cancelar',
      },
      HERO: {
        PHOTO_ALT: 'Foto del usuario',
        BANNED: 'Bloqueada',
        VERIFIED: 'Identidad verificada',
        DOCUMENT_VERIFIED: 'Documento verificado',
        SIGNUP: 'Alta',
        EDIT: 'Editar',
        SUPPORT_CHAT: 'Chat de soporte',
        BAN: 'Bloquear cuenta',
        UNBAN: 'Desbloquear',
      },
      BAN: {
        STATUS_TITLE: 'Cuenta bloqueada',
        SINCE: 'desde {{date}}',
        EDIT_REASON: 'Editar motivo',
        INTERNAL_NOTE_HINT: 'Nota interna (no la ve el usuario)',
        REASONS: {
          PAYMENT_ISSUE: {
            TITLE: 'Impago o incidencia de pago',
            BODY: 'Esto se debe a una incidencia pendiente relacionada con un pago.',
          },
          USER_REPORT: {
            TITLE: 'Denuncia de otro usuario',
            BODY: 'Esto se debe a una incidencia reportada por otro usuario de la comunidad.',
          },
          RULES_VIOLATION: {
            TITLE: 'Incumplimiento de normas',
            BODY: 'Esto se debe a un incumplimiento de las normas de uso de Waiis.',
          },
          ACCOUNT_REVIEW: {
            TITLE: 'Nuestro equipo está revisando tu cuenta.',
            BODY: 'Hemos detectado un problema que necesitamos revisar.',
          },
        },
        MODAL_TITLE: 'Bloquear la cuenta de {{name}}',
        MODAL_TITLE_NEW: 'Bloquear la cuenta',
        MODAL_TITLE_EDIT: 'Editar el bloqueo',
        MODAL_INTRO: 'El usuario perderá el acceso a la app y verá una pantalla con este motivo, en su propio idioma. Sus rutinas activas quedan pausadas hasta que se desbloquee la cuenta. El texto no se puede editar: elige el caso que corresponda.',
        REASON_LABEL: 'Motivo',
        REASON_REQUIRED: 'Elige el motivo del bloqueo.',
        NOTE_LABEL: 'Nota interna (opcional)',
        NOTE_PLACEHOLDER: 'Detalle del caso para el equipo. El usuario no lo ve.',
        NOTE_COUNT: '{{count}}/500 caracteres',
        PREVIEW_LABEL: 'Así lo verá el usuario, traducido a su idioma',
        PREVIEW_TITLE_EMPTY: 'Elige un motivo',
        PREVIEW_BODY_EMPTY: 'Aquí verás el texto que lee el usuario.',
        SAVE_CHANGES: 'Guardar cambios',
        BAN_ACCOUNT: 'Bloquear cuenta',
        UPDATED_TITLE: 'Motivo actualizado',
        UPDATED_TEXT: 'El usuario verá el nuevo motivo en la pantalla de bloqueo.',
        BANNED_TITLE: 'Cuenta bloqueada',
        BANNED_TEXT: 'El usuario verá la pantalla de bloqueo con el motivo indicado.',
        UNBAN_TITLE: 'Desbloquear cuenta',
        UNBAN_TEXT: 'El usuario recuperará el acceso a la app de inmediato.',
        UNBAN_BUTTON: 'Desbloquear',
        UNBAN_DONE_TITLE: 'Cuenta desbloqueada',
        UNBAN_DONE_TEXT: 'El usuario ya puede volver a usar la app.',
        ERROR_BAN: 'No se ha podido bloquear la cuenta',
        ERROR_UNBAN: 'No se ha podido desbloquear la cuenta',
        ERROR_RETRY: 'Inténtalo de nuevo.',
      },
      METRICS: {
        BALANCE: 'Saldo actual',
        BALANCE_SUB: 'En la wallet del usuario',
        COLLECTED: 'Cobrado de pasajeros',
        COLLECTED_SUB: 'Total como conductor',
        DRIVER_TRIPS: 'Viajes como conductor',
        RIDER_TRIPS: 'Viajes como pasajero',
        SUCCESS: '{{percent}}% éxito',
        CREDITS: 'Créditos',
        CREDITS_SUB: 'Saldo de créditos',
        PROFILE_COMPLETED: 'Perfil completado',
        PROFILE_COMPLETED_SUB: 'Email, teléfono, documento y selfie',
        ARIA: 'Indicadores del usuario',
      },
      PENDING: {
        TITLE: 'Dinero pendiente',
        SUBTITLE: 'Lo que todavía ha de entrar o salir del saldo por viajes, referidos y promociones.',
        KPI: 'Pendiente',
        KPI_SUB: 'Entrará o saldrá del saldo',
        KPI_NEXT: 'Siguiente: {{date}}',
        KPI_NO_DATE: 'Sin fecha',
        KPI_NOTHING: 'Nada pendiente',
        KPI_CTA: 'Ver en «Pendiente» →',
        KPI_CTA_ON: '✓ En «Pendiente»',
        NET: 'Neto',
        REFRESH: 'Actualizar',
        LOAD_ERROR: 'No se ha podido cargar lo que tiene pendiente.',
        RETRY: 'Reintentar',
        EMPTY: 'No tiene nada pendiente de entrar ni de salir del saldo.',
        INFO_NOTE: 'Las filas «Informativo» no suman al neto: la retirada ya salió del saldo y lo cobrado solo vuelve si el viaje falla.',
        NO_DATE: 'Sin fecha',
        NEXT_CREDIT: 'En el próximo abono',
        BEFORE: 'Antes del {{date}}',
        RANGE: '{{from}} → {{to}}',
        PROGRESS: '{{done}}/{{required}} viajes',
        UNKNOWN_PERSON: 'Sin nombre',
        GROUP: { IN: 'Por entrar', OUT: 'Por salir', INFO: 'Informativo (no suma al neto)' },
        COL: { CONCEPT: 'Concepto', REASON: 'Motivo', WHEN: 'Cuándo', AMOUNT: 'Importe', OPEN: 'Abrir la pestaña' },
        TYPE: {
          TRIP_VERIFYING: 'Verificando · {{count}} viajes',
          TRIP_DEFERRED: 'Diferido · {{count}} viajes',
          TRIP_IDENTITY: 'Identidad del pasajero · {{count}} viajes',
          PVP_CAE_REFUND: 'Devolución del bono CAE (PVP)',
          REFERRAL: 'Referido · {{name}}',
          REFERRAL_CODE: 'Código {{code}} · {{name}}',
          PVP_PROMO: 'Promo PVP',
          TRIP_PROMO: 'Promo de viajes',
          INCENTIVE: 'Incentivo de empresa',
          PENALTY_IN: 'Penalización a favor',
          PENALTY_OUT: 'Penalización pendiente',
          PENALTY_DEBT: 'Deuda de penalizaciones · {{count}}',
          REJECTED_CHARGE: 'Cobro rechazado · {{count}} viajes',
          UNSETTLED_CHARGE: 'Cobrado, viaje por hacer · {{count}}',
          WITHDRAWAL_HELD: 'Retirada retenida · {{count}}',
        },
        DETAIL: {
          TRIP_VERIFYING: 'Importe estimado; entra cuando el viaje queda válido',
          TRIP_DEFERRED_REINFORCED: 'Abono aplazado por la verificación reforzada',
          TRIP_DEFERRED_CASH: 'Abono aplazado según el historial y el importe',
          TRIP_IDENTITY: 'El pasajero aún no ha verificado el DNI',
          PVP_CAE_REFUND: 'Si verifica el DNI antes del plazo',
          REFERRAL: {
            PENDING: 'Pendiente de cumplir las condiciones',
            PENDING_TRIPS: 'Faltan viajes verificados',
            PENDING_VERIFICATION: 'Falta verificar el DNI',
            PENDING_REGISTRATION: 'Aún no se ha registrado',
          },
          REFERRAL_CODE: 'En el primer viaje verificado del invitado',
          PVP_PROMO: '2 viajes de más de 10 km',
          TRIP_PROMO: 'Cuando haga los viajes de la promo',
          INCENTIVE: 'Cuando complete la tarea de la campaña',
          PENALTY_IN: 'Cancelación de la otra parte; si no se encuentra sustituto',
          PENALTY_OUT: 'Cancelación tardía',
          PENALTY_DEBT: 'Se descuenta de los próximos abonos',
          REJECTED_CHARGE: 'Tarjeta rechazada; saldo negativo si el viaje se verifica',
          UNSETTLED_CHARGE: 'Ya salió del saldo; vuelve si el viaje se deshace o no se verifica',
          WITHDRAWAL_HELD: 'Ya fuera del saldo; llegará al banco',
        },
        REASON: {
          VERIFYING: 'Verificación',
          REINFORCED: 'Reforzada',
          CASH_DELAY: 'Revisión',
          MANUAL_REVIEW: 'Revisión manual',
          IDENTITY: 'Identidad',
          REFERRAL: 'Referido',
          PROMO: 'Promoción',
          INCENTIVE: 'Incentivo',
          PENALTY: 'Penalización',
          REJECTED: 'Rechazado',
          UPCOMING_TRIP: 'Viaje por hacer',
          OTHER: 'Otros',
        },
      },
      TABS: {
        ARIA: 'Sección del usuario',
        PROFILE: 'Perfil',
        TRIPS: 'Viajes',
        PENDING: 'Pendiente',
        MOVEMENTS: 'Movimientos',
        NEW_MOVEMENT: 'Nuevo movimiento',
      },
      IDENTITY: {
        TITLE: 'Identidad',
        ID: 'ID',
        FULL_NAME: 'Nombre y apellidos',
        DOCUMENT: 'Documento',
        DOCUMENT_TYPE: 'Tipo de documento',
        BIRTH_DATE: 'Fecha de nacimiento',
        SIGNUP_DATE: 'Fecha de alta',
      },
      CONTACT: {
        TITLE: 'Contacto',
        EMAIL: 'Email',
        PHONE: 'Teléfono',
        ADDRESS: 'Dirección',
        APP_LANGUAGE: 'Idioma de la app',
      },
      PERMISSIONS: {
        TITLE: 'Permisos del dispositivo',
        SUB: 'Lo que la app puede usar en el móvil del usuario.',
        ALLOWED: 'Permitido',
        DENIED: 'Denegado',
        NOTIFICATIONS: 'Notificaciones',
        LOCATION: 'Ubicación',
        BACKGROUND_LOCATION: 'Ubicación en segundo plano',
        PHYSICAL_ACTIVITY: 'Actividad física',
        BLUETOOTH: 'Bluetooth',
        AND: ' y ',
        CANNOT_VERIFY: 'No se pueden verificar sus viajes: falta {{missing}}.',
        CAN_VERIFY: 'Puede verificar sus viajes.',
      },
      PVP: {
        TITLE: 'Bonificación precio completo',
        FRAUD_TAG: 'Fraude',
        SUB: 'Si hace 2 viajes verificados de más de 10 km a PVP, se le ingresa el importe en la wallet.',
        FRAUD_CONSEQUENCE: 'Al cobrarla pasa a verificación reforzada + sin coste 0.',
        IN_PROGRESS: 'En curso',
        COMPLETED: 'Completada',
        ACTIVATED_BY: 'Activada por {{name}} el {{date}}',
        LAST_CANCELLED: 'Última cancelada el {{date}}',
        NONE: 'Sin promoción',
        CANCEL: 'Cancelar promoción',
        ACTIVATE: 'Activar promoción PVP',
        LOADING: 'Cargando…',
        NO_PROMO_IN_PROGRESS: 'Sin promoción en curso',
        PROGRESS: '{{done}} de {{total}} viajes',
        STEP_INACTIVE: 'Sin activar',
        STEP_ACTIVATED: 'Activada',
        STEP_TRIP: 'Viaje {{n}}',
        STEP_TRIP_DONE: 'hecho',
        STEP_PAID: 'Ingresado',
        STEP_TRIP_TITLE: 'Viaje verificado de más de 10 km a PVP',
        STEP_TRIP_TITLE_DATE: 'Viaje verificado de más de 10 km a PVP ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activada por {{name}}',
        STEP_PAID_TITLE: '{{amount}} en la wallet al completar los viajes',
        MODAL_TITLE: 'Activar promoción PVP',
        MODAL_INTRO: '¿Cuánto le ofreces a {{name}}? Se le ingresa en la wallet cuando complete 2 viajes verificados de más de 10 km a PVP a partir de ahora.',
        HINT_START: 'La oferta de partida.',
        HINT_COMPLAINT: 'Si se queja o amenaza con irse.',
        OFFER_OTHER: 'Ofrecer otra cantidad',
        OTHER_LABEL: 'Otra cantidad',
        OTHER_PLACEHOLDER: 'Ej. 4',
        OTHER_HINT: 'Solo si no acepta 3 € ni 5 €.',
        OTHER_REMOVE: 'Quitar otra cantidad',
        CONFIRM: 'Confirmar',
        ACTIVATED_TITLE: 'Promoción activada',
        ACTIVATED_TEXT: 'Al completar 2 viajes a PVP se le ingresarán {{amount}}.',
        ERROR_ACTIVATE: 'No se ha podido activar la promoción',
        ERROR_CANCEL: 'No se ha podido cancelar la promoción',
        ERROR_403: 'No tienes permiso para gestionar la promoción de este usuario',
        CANCEL_TITLE: '¿Cancelar la promoción?',
        CANCEL_TEXT: 'El usuario dejará de optar a la bonificación. Podrás activarle otra después.',
        CANCEL_YES: 'Sí, cancelar',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancelando…',
        CANCEL_DONE: 'Cancelada',
      },
      TRIP: {
        TITLE: 'Promo por viajes',
        SUB: 'Elige importe, nº de viajes, km mínimos (desde 10), si van a PVP o a coste 0 y si cuentan como conductor, como pasajero o ambos. Al completarlos (verificados) se le ingresa el importe en la wallet. Puede tener varias en curso.',
        SUB_ACTIVE: 'Al completar {{count}} viaje(s) verificado(s) de más de {{km}} km {{type}} se le ingresa el importe en la wallet.',
        IN_PROGRESS: 'En curso',
        COMPLETED: 'Completada',
        TYPE_PVP: 'a PVP',
        TYPE_WITHOUT_COST: 'a coste 0',
        TYPE_ANY: 'a PVP o a coste 0',
        TYPE_BADGE_PVP: 'Viajes a PVP',
        TYPE_BADGE_WITHOUT_COST: 'Viajes a coste 0',
        TYPE_BADGE_ANY: 'Cualquiera',
        TYPE_HINT_PVP: 'Solo cuentan los viajes a precio completo.',
        TYPE_HINT_WITHOUT_COST: 'Solo cuentan los viajes sin coste para el pasajero.',
        TYPE_HINT_ANY: 'Cuentan los viajes a precio completo y los de coste 0.',
        ACTIVATED_BY: 'Activada por {{name}} el {{date}}',
        LAST_CANCELLED: 'Última cancelada el {{date}}',
        NONE: 'Sin promoción',
        CANCEL: 'Cancelar promoción',
        ACTIVATE: 'Activar promo por viajes',
        LOADING: 'Cargando…',
        NO_PROMO_IN_PROGRESS: 'Sin promoción en curso',
        PROGRESS: '{{done}} de {{total}} viajes',
        STEP_INACTIVE: 'Sin activar',
        STEP_ACTIVATED: 'Activada',
        STEP_TRIP: 'Viaje {{n}}',
        STEP_TRIP_DONE: 'hecho',
        STEP_PAID: 'Ingresado',
        STEP_TRIP_TITLE: 'Viaje verificado de más de {{km}} km {{type}}',
        STEP_TRIP_TITLE_DATE: 'Viaje verificado de más de {{km}} km {{type}} ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activada por {{name}}',
        STEP_PAID_TITLE: '{{amount}} en la wallet al completar los viajes',
        MODAL_TITLE: 'Activar promo por viajes',
        FIELD_AMOUNT: 'Importe',
        FIELD_ROUTES: 'Número de viajes',
        FIELD_KM: 'Km mínimos por viaje',
        KM_HINT: 'Nunca menos de {{min}} km.',
        KM_OTHER: 'Otros km',
        ROUTES_OTHER: 'Otro nº de viajes',
        CHIP_OTHER: 'Otro',
        TYPE_CHIP_PVP: 'PVP',
        TYPE_CHIP_WITHOUT_COST: 'Coste 0',
        TYPE_CHIP_ANY: 'Cualquiera',
        KM_CHANGE: 'Cambiar km mínimos ({{km}} km)',
        FRAUD_NOTE: 'No afecta a su estado de fraude.',
        CONFIRM_SUMMARY: 'Activar · {{amount}} por {{count}} viaje(s)',
        PROGRESS_LAST: 'Último viaje: {{date}}',
        PROGRESS_NONE: 'Aún ningún viaje',
        PROGRESS_PAID: 'Ingresado {{date}}',
        ADD_ANOTHER: 'Añadir otra promo',
        FIELD_USER: 'Usuario',
        USER_SEARCH_PLACEHOLDER: 'Buscar nombre, email o teléfono…',
        USER_SEARCH_HINT: 'Escribe al menos 2 letras para buscar.',
        USER_SEARCHING: 'Buscando…',
        USER_NOT_FOUND: 'Ningún usuario coincide.',
        USER_CHANGE: 'Cambiar usuario',
        FIELD_ROLE: 'Quién cuenta',
        ROLE_ANY: '',
        ROLE_DRIVER: 'como conductor',
        ROLE_RIDER: 'como pasajero',
        ROLE_CHIP_ANY: 'Conductor o pasajero',
        ROLE_CHIP_DRIVER: 'Solo conductor',
        ROLE_CHIP_RIDER: 'Solo pasajero',
        ROLE_BADGE_ANY: 'Conductor o pasajero',
        ROLE_BADGE_DRIVER: 'Solo conductor',
        ROLE_BADGE_RIDER: 'Solo pasajero',
        PRESET_HINT: '3 €: 2 viajes como conductor o pasajero, a PVP o a coste 0. 5 €: 2 viajes solo como conductor, a PVP. Puedes cambiar cualquier campo.',
        PICK_PROMO: 'Promoción a mostrar',
        FIELD_TYPE: 'Tipo de viaje',
        OTHER_LABEL: 'Otra cantidad',
        OTHER_PLACEHOLDER: 'Otra',
        CONFIRM: 'Confirmar',
        ACTIVATED_TITLE: 'Promoción activada',
        ACTIVATED_TEXT: 'Al completar {{count}} viaje(s) de más de {{km}} km {{type}} se le ingresarán {{amount}}.',
        ERROR_ACTIVATE: 'No se ha podido activar la promoción',
        ERROR_CANCEL: 'No se ha podido cancelar la promoción',
        ERROR_403: 'No tienes permiso para gestionar la promoción de este usuario',
        CANCEL_TITLE: '¿Cancelar la promo por viajes?',
        CANCEL_TEXT: 'El usuario dejará de optar al importe. Podrás activarle otra después.',
        CANCEL_YES: 'Sí, cancelar',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancelando…',
        CANCEL_DONE: 'Cancelada',
      },
    },
  },
};
